import React from "react";
import "./CardComponent.css";

function CardComponent({ onClick, title, description, image }) {
  return (
    <div className="col-sm-4 col-6" onClick={onClick} style={{ cursor: "pointer" }}>
      <div className="card h-100 shadow-sm">
        <img src={image} className="card-img-top img-fluid" alt={title} />
        <div className="card-body p-2">
          <h5 className="card-title">{title}</h5>
          <p className="card-text">{description}</p>
          {/* <a href="#" className="btn btn-primary">Learn More</a> */}
        </div>
      </div>
    </div>
  );
}

export default CardComponent;
